var map = {
	"./en": 79280,
	"./en.md": 79280,
	"./fr": 65699,
	"./fr.md": 65699,
	"./he": 62936,
	"./he.md": 62936,
	"./ru": 7826,
	"./ru.md": 7826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60907;